export const emptyQuery = {
  toSQL: () => {
    return {
      sql: `select feed.id from feed where 1 = 0`,
      params: [],
    };
  },
  execute: () => Promise<[]>,
  getUsedTables: () => [],
};

export function emptyOf<T>(query: T): T {
  return emptyQuery as unknown as T;
}
